export default __webpack_public_path__ + "static/media/Junge-schläft.05bdd5a8.webp";